import { Navigate } from 'react-router-dom';
import { useAuthGuard } from '../../features/auth/hooks/useAuthGuard';
import { hasAuth0Config } from '../../shared/config/env';
import { ROUTES } from '../../shared/config/routes';

const authEnabled = hasAuth0Config();

function ProtectedRouteEnabled({ children }) {
  const { isLoading, isAuthenticated, error } = useAuthGuard();

  if (isLoading) {
    return null;
  }

  if (error) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return children;
}

export function ProtectedRoute({ children }) {
  if (!authEnabled) {
    return children;
  }

  return <ProtectedRouteEnabled>{children}</ProtectedRouteEnabled>;
}
